module.exports = __webpack_public_path__ + "img/zhangjiakou-9c82da.png";